import React from 'react'
import './../css/GeneralPages.css'
import PageTitle from '../includes/PageTitle'
import Footer from '../includes/Footer'

export default function TermsAndConditions() {
  return (
    <>
      <PageTitle title="Terms and Condition - ALMOSTINVISIBLE" />
        <div className="gen-intro px-4">
          <h1 className="unbounded text-fluid">
            Terms & Condition
          </h1>
        </div>

        <div className="gen-content container">
        <section>
        <h2 className="unbounded">1. Introduction</h2>
        <p>
          Welcome to ALMOSTINVISIBLE. These Terms and Conditions govern your use of our website and services. By accessing or using our website, you agree to be bound by these terms. If you do not agree with any part of these terms, you must not use our services.
        </p>
      </section>

      <section>
        <h2 className="unbounded">2. Use of the Website</h2>
        <p>
          You agree to use the website only for lawful purposes and in accordance with these Terms and Conditions. You are responsible for ensuring that any information you provide on our website is accurate and up to date.
        </p>
      </section>

      <section>
        <h2 className="unbounded">3. Account Registration</h2>
        <p>
          To access certain features of the website, you may be required to create an account. You agree to provide accurate and complete information during the registration process and to update your information if necessary. You are responsible for maintaining the confidentiality of your account credentials.
        </p>
      </section>

      <section>
        <h2 className="unbounded">4. Products and Orders</h2>
        <p>
          ALMOSTINVISIBLE offers products for sale through our website. We reserve the right to limit the quantities of any products or services that we offer. All orders are subject to acceptance and availability. We may refuse or cancel any order at our sole discretion.
        </p>
      </section>

      <section>
        <h2 className="unbounded">5. Pricing and Payments</h2>
        <p>
          Prices for our products are listed on the website and are subject to change without notice. All payments for orders are processed through secure payment gateways. You agree to provide accurate payment information and authorize the charges for your orders.
        </p>
      </section>

      <section>
        <h2 className="unbounded">6. Shipping and Delivery</h2>
        <p>
          We will process your orders as promptly as possible. However, shipping times may vary depending on the location and availability of the products. ALMOSTINVISIBLE is not responsible for delays caused by external factors such as weather or carrier issues.
        </p>
      </section>

      <section>
        <h2 className="unbounded">7. Returns and Exchanges</h2>
        <p>
          ALMOSTINVISIBLE accepts returns and exchanges according to our Return Policy, which is available on the website. Products must be returned within the specified period and in their original condition. Shipping costs for returns are the responsibility of the customer unless otherwise stated.
        </p>
      </section>

      <section>
        <h2 className="unbounded">8. Intellectual Property</h2>
        <p>
          All content on the website, including but not limited to text, images, logos, and designs, are the property of ALMOSTINVISIBLE and are protected by intellectual property laws. You may not use, reproduce, or distribute any content from the website without our express permission.
        </p>
      </section>

      <section>
        <h2 className="unbounded">9. Limitation of Liability</h2>
        <p>
          ALMOSTINVISIBLE shall not be held liable for any direct, indirect, incidental, or consequential damages arising out of your use or inability to use our website or products. We do not guarantee the accuracy or reliability of the content on our website.
        </p>
      </section>

      <section>
        <h2 className="unbounded">10. Privacy Policy</h2>
        <p>
          Your privacy is important to us. Please review our Privacy Policy to understand how we collect, use, and protect your personal information. By using our website, you agree to the collection and use of information in accordance with our Privacy Policy.
        </p>
      </section>

      <section>
        <h2 className="unbounded">11. Modifications to Terms</h2>
        <p>
          ALMOSTINVISIBLE reserves the right to update or modify these Terms and Conditions at any time. Any changes will be posted on this page, and the date of the latest revision will be indicated at the bottom of the page. You are advised to review this page periodically for any updates.
        </p>
      </section>

      <section>
        <h2 className="unbounded">12. Governing Law</h2>
        <p>
          These Terms and Conditions are governed by and construed in accordance with the laws of the jurisdiction where ALMOSTINVISIBLE is registered. Any disputes arising from the use of the website shall be resolved in the competent courts of that jurisdiction.
        </p>
      </section>

      <section>
        <h2 className="unbounded">13. Contact Us</h2>
        <p>
          If you have any questions or concerns regarding these Terms and Conditions, please feel free to contact us at: <strong>support@almostinvisible.com</strong>.
        </p>
      </section>

        <p>Last updated: December 2024</p>
      
        </div>
    <Footer />
    </>
  )
}
